import * as _ from 'underscore';

import { IViz, VizType } from '../models/Viz';
import { Module } from '../Module';
import { ServerService } from '../services/ServerService';
import { VizService } from '../services/VizService';

export interface IWorkbookRevisionVizViewerScope extends ng.IScope {
  viz: IViz;
  headerTitleText: string;
  editedByText: string;
  lastModifiedText: string;
  closeButtonText: string;
  closePreview: () => void;
}

export interface IWorkbookRevisionVizViewerStateParams extends ng.ui.IStateParamsService {
  revisionNumber: number;
  sheetUrlId: string;
  workbookUrlId: string;
}

export class WorkbookRevisionVizViewerCtrl {

  private sheetUrlId: string;
  private workbookUrlId: string;
  private revisionNumber: number;

  public static $inject = [
    '$location',
    '$scope',
    '$stateParams',
    '$translate',
    'ServerService',
    'VizService',
  ];

  constructor(
    $location: ng.ILocationService,
    $scope: IWorkbookRevisionVizViewerScope,
    $stateParams: IWorkbookRevisionVizViewerStateParams,
    $translate: ng.translate.ITranslateService,
    server: ServerService,
    vizService: VizService
  ) {
    $scope.headerTitleText = $translate.instant('revisionHistoryPreviewTitle', { REVISION_NUMBER: $stateParams.revisionNumber });
    $scope.closePreview = () => { window.close(); };

    const hasSheetUrlId = !_.isUndefined($stateParams.sheetUrlId);

    const pathElements = _.compact([$stateParams.workbookUrlId, $stateParams.sheetUrlId, 'history', $stateParams.revisionNumber]);
    $scope.viz = {
      path: pathElements.join('/'),
      vizType: VizType.RevisionPreview,
      siteUrlName: server.sessionSiteUrlName(),
      params: $location.search()
    };

    this.workbookUrlId = $stateParams.workbookUrlId;
    this.revisionNumber = $stateParams.revisionNumber;

    $scope.$watch('viz.path', (newPath: string) => {
      const splitPath = newPath.split('/');

      // if originally had the sheetUrlId, include the sheet so the url is of the format someWorkbook/someSheet/history/4
      // If originally did not, keep it undefined so the url stays of the format someWorkbook/history/4
      this.sheetUrlId = hasSheetUrlId ? splitPath[1] : undefined;
      vizService.updateWorkbookRevisionVizPath($scope, {workbookUrlId: this.workbookUrlId, sheetUrlId: this.sheetUrlId, revisionNumber: this.revisionNumber});
    });

    vizService.reloadOnLocationChange($scope);
  }
}

Module.instance().controller('WorkbookRevisionVizViewerCtrl', WorkbookRevisionVizViewerCtrl);
